import { WidgetsParcelDeclarationMain } from '@/widgets/parcel-declaration';

export const PagesParcelDeclarationMain = () => <WidgetsParcelDeclarationMain />;
